<template>
  <div class="SearchedPartsTableComponent DataTables">
    <p>{{lang.infotext_1}}: <span class="pm-part">{{selectedGenericPart}} </span></p>

    <p>{{lang.infotext_2}}:</p>
    <div v-if="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div> 
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from '@/Tools/Tools'

export default {
  name: 'SearchedPartsTableComponent',
  props:{
    lang: Object,
    source: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        mainTable: "",
        id: "SearchedPartsTableComponent",
        columns: [],
        colsAssign: [],
        searchedParts: []

      }
  },
  computed: {
    selectedGenericPart(){
      let pm = this.lang.infotext_3;  
      if (this.$route.query.source == "PartDetails") {
        return this.$route.query.pn;
      }
      for (let prop in this.$store.getters.selectedRows[0]){
        console.log(prop, this.$store.getters.selectedRows[0][prop].type)
        if (this.$store.getters.selectedRows[0][prop].type == "part number") {
          console.log("ok")
          pm = this.$store.getters.selectedRows[0][prop].value.display;
          break;
        }
      }    

      return pm;
    },
    // selectedGenericPartValue(){
    //   let pm = "";  

    //   for (let prop in this.$store.getters.selectedRows[0]){
        
    //     if (this.$store.getters.selectedRows[0][prop].type == "value"){
    //       pm = this.$store.getters.selectedRows[0][prop].value.display;
    //       break;
    //     }
    //   }    

    //   return pm;
    // },
    externalSearchResponseResult(){

      return this.$store.getters.externalSearchResponseResult;


    },
    dataTable(){
      return this.$store.getters.revisionHistory;
    },

    isData(){
        //return Object.keys(this.dataTable).length != 0
        return true
    },
    tabStatus(){
       return this.$store.getters.tabStatus;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    reloadedAfterAction() {
      return this.$store.getters.reloadedAfterAction;
    },
  },
  created () {

    this.createSearchTable();


  },
  watch: {
    externalSearchResponseResult: function () {

      
      this.createSearchTable();

    },
    tabStatus: function () {

      
      this.createSearchTable();

    },
    reloadedAfterAction: function (newValue) {
      console.log(newValue)
      console.log(newValue.name, this.id)
      if (newValue.name == this.id) {
        if (newValue.status == true) {

          this.createSearchTable();

          newValue.status = false;
          newValue.name = "";
          this.$store.dispatch("reloadAfterAction", newValue);
        }
      }

    }
  },
  updated() {



  },
  mounted: function () {

  },
  methods: {
    checkEndOfDate(date) {
      const now = new Date();
      const oneDay = 1000 * 60 * 60 * 24;

      if (date != null) {
        const endoflifeDate = new Date(date)
        const diffInTimeA = endoflifeDate.getTime() - now.getTime();
        const diffInDaysA = Math.round(diffInTimeA / oneDay);

        if (diffInDaysA < 365) {
          return true;
        } else {
          return false;
        }
      }
    },
    createSearchTable(){
      let vue = this;

      if (this.tabStatus == 0) {
        let chooseExternalSearchIdArr = [];
        for (let i = 0, lei = this.externalSearchResponseResult.length; i < lei; i++) {

          chooseExternalSearchIdArr.push(this.externalSearchResponseResult[i].searchId)

        }

        let obj = {
          //chooseExternalSearchId: ["e8343e5d-ef8b-49bc-9d68-a3a7b07d99e3"]//chooseExternalSearchIdArr
          chooseExternalSearchId: chooseExternalSearchIdArr
        }



        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSearchedParts", obj)
          .then((result) => {
            console.log(result)

            if (result.status == "OK") {

              vue.searchedParts = [];

              for (let i = 0, lei = result.data.length; i < lei; i++) {

                vue.searchedParts.push(result.data[i]);

              }


              vue.buildColumns();


            }


          })
      }
      // }else{
      //   this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPhysicalHandmadeParts")
      //   .then((result) => {
      //     console.log(result)
      //     if (result.status == "OK"){

      //       vue.searchedParts = [];

      //       for (let i = 0, lei = result.data.length; i < lei; i++){
              
      //         vue.searchedParts.push(result.data[i]); 
                
      //       }


      //       vue.buildColumns();


      //     }


      //   })
      // }
      
    },
    buildColumns(){

      this.columns = [
        {
          name: "DistributorPartId",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "Select",
          alignInColumn: "left",
          type: "checkbox",
        },
        {
          name: "ImageUrl",
          alignInColumn: "left",
          type: "image"
        },
        {
          name: "DistributorName",
          alignInColumn: "left",
          type: "badges"
        },
        {
          name: "DistributorPartNumber",
          alignInColumn: "left",
          type: "text"
        },
        // {
        //   name: "DistributorKey",
        //   alignInColumn: "left",
        //   type: "text"
        // },
        {
          name: "ManufacturerName",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "ManufacturerPartNumber",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "Description",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "DtasheetUrl",
          alignInColumn: "left",
          type: "link"
        },
        {
          name: "IsROHSCompliant",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "ProductDetailUrl",
          alignInColumn: "left",
          type: "link"
        },
        {
          name: "AvailableQuantity",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "LeadDays",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "EOL",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "EOS",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "TempMin",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: "TempMax",
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "DistributorPartId" },
        { "data": "DistributorPartId" },
        { "data": "ImageUrl" },
        { "data": "DistributorName" },
        { "data": "DistributorPartNumber" },
        // { "data": "DistributorKey" },
        { "data": "ManufacturerName" },
        { "data": "ManufacturerPartNumber" },
        { "data": "Description" },
        { "data": "DtasheetUrl" },
        { "data": "IsROHSCompliant" },
        { "data": "ProductDetailUrl" },
        { "data": "AvailableQuantity" },
        { "data": "LeadDays" },
        { "data": "EOL" },
        { "data": "EOS" },
        { "data": "TempMin" },
        { "data": "TempMax" },
      ]

      this.buildTable();
    },
    buildTable(){
          

          this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteAllAlternativeParts");
          this.$store.dispatch("deleteSelectedSearchedRows");


          var tableplace = document.getElementById(this.id);

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-' + this.columns[i].alignInColumn;

            let searchable = true;
            if (i == 0) {
              searchable = false;
            }

            el = {
              targets: i,
              searchable: searchable,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                if (data == null){
                  return "";
                }

                if (meta.settings.oInit.myColumnFormats[meta.col].type == "image"){

                  if ((data != null) && (data != "") && ((data.indexOf("http://") != -1) || (data.indexOf("https://") != -1))){

                    return "<img class=\"image\" height='40px' src='"+data+"'>";
                  }
                  return "<img class=\"imageSVG\" height='40px' src='/static/part.png'>";
                }else if (meta.settings.oInit.myColumnFormats[meta.col].type == "link"){
                  
                  
                  if (data.length != 0) {
                    let pos = data.indexOf("http");
                    if (pos > -1) {
                      return "<a href='" + data + "' target='_blank'>Link</a>";
                    } else {
                      return data;
                    }
                    
                  } else {
                    return "";
                  }
                  
                  
                  return "";
                }else if (meta.settings.oInit.myColumnFormats[meta.col].type == "checkbox"){  
                  let accepted = true
                  let checked = ""
                  let str = "<div class=\"custom-control custom-checkbox\"><input " + checked + "  type=\"checkbox\" class=\"custom-control checkbox_type custom-control-primary custom-control-sm select-alternative\" id=\"select_" + data +"\" value=\""+ accepted +"\"></div>";

                  return str;
                }
                if (meta.col == 13 || meta.col == 14) {
                  if (data == null || data == '') {
                    return "";
                  }
                  if (vue.checkEndOfDate(data) == true) {
                    return "<b-badge class='badge badge-danger '>" + Tools.longDateToShort(data, false) + "</b-badge>";
                  }
                  return Tools.longDateToShort(data, false);
                }
                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            var br = document.createElement("br");
            th.appendChild(br);

            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

          }


          var option = {};
          option.paging = false;
          option.info = false;
          option.dom = '<fBr<t>ip>';
          option.data= this.searchedParts;
          option.myColumnFormats = this.columns;
          option.select = true;
          option.order = [[3, "asc"]];

          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.buttons = [
            {
              extend: 'copy',
              className: 'btn-' + vue.variant,
              exportOptions: {
                  columns: ':visible'
              }
            },
            {
              extend: 'print',
              className: 'btn-' + vue.variant,
              messageTop: function () {
                return vue.lang.export_label_top;
              },
              exportOptions: {
                columns: ':visible'
              },
              autoPrint: true,
              style: 'fullWidth',
              
              customize: function ( win ) {
                  $(win.document.body)
                      .css( 'font-size', '10pt' )
                      

                  $(win.document.body).find( 'table' )
                      .addClass( 'compact' )
                      .css( 'font-size', 'inherit' );
              }
            },
            {
              extend: 'csv',
              className: 'btn-' + vue.variant,
              exportOptions: {
                columns: ':visible'
              },
            },
            {
              extend:'excel',
              exportOptions: {
                columns: ':visible'
              },
              className: 'btn-' + vue.variant,
                customize: function ( xlsx ){

                var sheet = xlsx.xl.worksheets['Parts.xml'];


            }},
            {
              extend: 'pdfHtml5',
              messageTop: function () {
                      return vue.lang.export_label_top;
              },
              className: 'btn-' + vue.variant,
              exportOptions: {
                columns: ':visible'
              },
              orientation: 'landscape',
              pageSize: 'A4',
              download: 'open',
              
              styles: {
                fullWidth: {
                    fontSize: 3,
                    bold: true,
                    alignment: 'right',
                    margin: [0,1900,0,80]		
                },
                subheader: {
                    fontSize: 4
                },
                superMargin: {
                    margin: [20, 0, 40, 0],
                    fontSize: 5,
                }
              },
              customize: function ( doc ) {
                

                doc.pageMargins = [10,10,10,10];
                
                doc.styles.title.fontSize = 9;
                doc.defaultStyle.fontSize = 7;
                doc.styles.tableHeader.fontSize = 9;
                doc.content[0].text = doc.content[0].text.trim();
                
                let numberOfHeaders = columnDefs.length;
                
                if ((numberOfHeaders > 10)&&(numberOfHeaders < 15)){
                  
                  doc.defaultStyle.fontSize = 5;
                  doc.styles.tableHeader.fontSize = 7;
                }else if((numberOfHeaders >= 15)&&(numberOfHeaders < 18)){
                  
                  doc.defaultStyle.fontSize = 5;
                  doc.styles.tableHeader.fontSize = 7;
                }else if(numberOfHeaders >= 18){
                  
                  doc.defaultStyle.fontSize = 3;
                  doc.styles.tableHeader.fontSize = 5;
                }
                
              },
              
            },
            {
            text: 'Json',
            exportOptions: {
              columns: ':visible'
            },
            className: 'btn-' + vue.variant,
                action: function ( e, dt, button, config ) {
                    var data = dt.buttons.exportData();

                    $.fn.dataTable.fileSave(
                        new Blob( [ JSON.stringify( data ) ] ),
                        'Parts.json'
                    );
                }
            },
            {
              extend: 'colvis',
              className: 'btn-' + vue.variant,
              
            },
          ];
          option.initComplete = function () {


          

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          var vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );

          let _mainTable = this.mainTable;

          this.mainTable
            .on( 'select', function ( e, dt, type, indexes ) {

              var rowData = _mainTable.rows( indexes ).data();
              

              vue.$store.dispatch("setSelectedSearchedRows", rowData[0])

            })
            .on( 'user-select', function ( e, dt, type, cell, originalEvent ) {
                if ( $(originalEvent.target).index() === 0 ) {
                    e.preventDefault();
                }
            } )
            .on( 'deselect', function ( e, dt, type, indexes ) {
              
              vue.$store.dispatch("deleteSelectedSearchedRows");
            })

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          

          $("#t_"+this.id + ' tbody').on( 'change', 'input', function (e) {
            
            
            let temp = this.id.split("_")
console.log(temp)
            const obj = {
              distributorPartId: temp[1]
            }

            if (this.checked == true){
              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_addAlternativePart", obj)
              
            }else{
              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteAlternativePart", obj)
              
            }
            

            

          })

        },


  }
}
</script>


<style lang="scss">
  .SearchedPartsTableComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      //border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .pm-part{
      font-size: 20px;
    }
    .dropdown-item.active {
      color: #fff;
      
      background-color: #2f2f2f;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/SearchedPartsTableComponent.vue